export default __webpack_public_path__ + "static/media/send_message_wa.ecfb80be.mp3";